angular.module("acl.visualizer.statistics", [
  "acl.common.event",
  "acl.visualizer.dataModel",
  "acl.visualizer.formatters",
  "templates-visualizer",
]);
